export const getRequestUrl = () => location.host + location.pathname

const getCookie = (name: string): string | null => {
  if (typeof document !== "undefined") {
    const matches = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/([$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1")}=([^;]*)`))

    return matches ? decodeURIComponent(matches[1]) : null
  }

  return null
}

export const getYandexClientId = () => getCookie("_ym_uid")
